import { ScheduleState, scheduleMachine } from 'domains/signup/consultationSchedule/scheduleMachine';
import { isArray } from 'lodash';
import { createActorContextFromActor } from 'utils/xstate/context';

export const ScheduleContext = createActorContextFromActor<typeof scheduleMachine>();

export const withScheduleMachineState = (Component: React.FC, matchingState: ScheduleState | ScheduleState[]) => {
  return (props: Record<string, unknown>) => {
    const matchesState = ScheduleContext.useSelector(state => {
      if (isArray(matchingState) && matchingState.some(s => state.matches(s))) {
        return true;
      }

      if (state.matches(matchingState as ScheduleState)) {
        return true;
      }

      return false;
    });

    if (matchesState) {
      return <Component {...props} />;
    }
    return null;
  };
};
